import WorkareasGrid from "./work-area-grid";
export default WorkareasGrid;
